<div (click)="toggleSummary()" class="card">
  <div class="card-detail" *ngIf="!isSummary">
    <div class="command-card-header">
      <h5 class="mb-0">
        <i
          *ngIf="needsReview"
          class="mdi mdi-alert-circle-outline mr-1"
          ngbTooltip="This command requires approval"
          placement="top"
          container="body"
          triggers="hover"
        ></i>
        {{ title }}
      </h5>
    </div>
    <p class="small mb-0">Notes: {{ notes }}</p>
    <p class="small mb-0">Account Id: {{ accountId }}</p>
    <p class="small mb-0">Created {{ created | ago }}</p>
  </div>

  <div class="card-summary" *ngIf="isSummary">
    <p class="summary-container">
      <span class="small title">
        <i
          *ngIf="needsReview"
          class="mdi mdi-alert-circle-outline mr-1"
          ngbTooltip="This command requires approval"
          placement="top"
          container="body"
          triggers="hover"
        ></i>
        {{ title }}
      </span>
      <span class="small ago">{{ created | ago }}</span>
    </p>
  </div>
</div>
